import { InboxFilter_Completed, InboxFilter_Accepted, InboxFilter_InputRequired, InboxFilter_Pending, InboxFilter_Resulted } from './types.js';
export const InboxFilters_LabelMap = {
    [InboxFilter_InputRequired]: 'Provide Info',
    [InboxFilter_Pending]: 'Pending',
    [InboxFilter_Resulted]: 'New Results',
    [InboxFilter_Completed]: 'Completed',
    [InboxFilter_Accepted]: 'Accepted'
};
//# sourceMappingURL=consts.js.map